
<template>
    <div>
        <div class="w-screen min-h-screen flex justify-center items-center align-middle">
            <div class="h-full max-w-2xl w-full md:m-4">
                <div class="h-full w-full relative">
                    <div class="mx-auto md:px-4 h-full">
                        <div v-if="JSON.parse(stripe_info)"
                            class="bg-white rounded-3xl md:rounded-2xl shadow-2xl p-10 flex flex-col w-full items-center justify-center">
                            <img class="max-h-[150px] max-w-[200px] mx-auto mb-12" :src="this.client_logo" alt="screenshot">

                            <div v-if="success == '1'" class="w-full">
                                <svg class="mb-4 h-20 w-20 mx-auto" viewBox="0 0 20 20"
                                    :fill="JSON.parse(client).main_color">
                                    <path fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                        clip-rule="evenodd" />
                                </svg>

                                <h2 class="text-2xl mb-4 text-gray-800 text-center font-bold">
                                    {{ $t("Booking Success!") }}
                                </h2>

                                <small class="w-full text-center block">Booking ID:</small>
                                <div
                                    class="flex flex-col items-center justify-center rounded-md bg_primary_color_lightest px-2 py-1 text-xs font-medium primary_color border primaryBorder w-full mb-4 space-y-1">
                                    <h4 class="text-center">
                                        {{ stripe_info ? JSON.parse(JSON.parse(stripe_info)['id']).join(', ') : null }}
                                    </h4>
                                </div>

                                <div class="text-gray-600 mb-8 text-center">
                                    {{
                                        $t('thank-you-youre-booking-was-successful-we-will-send-you-an-email-to-formdata-email-with-the-booking-details',
                                            [JSON.parse(stripe_info)['email']]) }}
                                </div>
                                <div class="text-gray-600 mb-8 text-center">
                                    {{
                                        $t('You can close this page') }}.
                                </div>

                                <button @click="goToRoomSelection()"
                                    class="w-40 block mx-auto focus:outline-none py-2 px-5 rounded-lg shadow-sm text-center text-gray-600 bg-white hover:bg-gray-100 font-medium border">
                                    {{ $t('back-to-home') }}</button>
                            </div>
                            <div v-else class="w-full">
                                <svg xmlns="http://www.w3.org/2000/svg" class="mb-8 h-20 w-20 mx-auto"
                                    xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="3 3 16 16">
                                    <g transform="matrix(2 0 0 2-11-2071.72)">
                                        <path transform="translate(7 1037.36)"
                                            d="m4 0c-2.216 0-4 1.784-4 4 0 2.216 1.784 4 4 4 2.216 0 4-1.784 4-4 0-2.216-1.784-4-4-4"
                                            :fill="JSON.parse(client).main_color" />
                                        <path
                                            d="m11.906 1041.46l.99-.99c.063-.062.094-.139.094-.229 0-.09-.031-.166-.094-.229l-.458-.458c-.063-.062-.139-.094-.229-.094-.09 0-.166.031-.229.094l-.99.99-.99-.99c-.063-.062-.139-.094-.229-.094-.09 0-.166.031-.229.094l-.458.458c-.063.063-.094.139-.094.229 0 .09.031.166.094.229l.99.99-.99.99c-.063.062-.094.139-.094.229 0 .09.031.166.094.229l.458.458c.063.063.139.094.229.094.09 0 .166-.031.229-.094l.99-.99.99.99c.063.063.139.094.229.094.09 0 .166-.031.229-.094l.458-.458c.063-.062.094-.139.094-.229 0-.09-.031-.166-.094-.229l-.99-.99"
                                            fill="#fff" />
                                    </g>
                                </svg>

                                <h2 class="text-2xl mb-8 text-gray-800 text-center font-bold">
                                    {{ $t("Payment failed!") }}
                                </h2>

                                <div class="text-gray-600 mb-8 text-center">
                                    {{ $t('Something went wrong with the payment') }} <br />
                                    {{ $t("Don't worry, no money has been transferred yet") }}. <br />
                                    {{ $t("please try again") }}.
                                </div>

                                <button @click="goBackToPayment()"
                                    class="w-40 block mx-auto focus:outline-none py-2 px-5 rounded-lg shadow-sm text-center text-gray-600 bg-white hover:bg-gray-100 font-medium border">
                                    {{ $t('Try again') }}</button>
                            </div>

                        </div>
                        <div v-else
                            class="bg-white rounded-3xl md:rounded-2xl shadow-2xl p-10 flex flex-col w-full items-center justify-center">
                            <img class="max-h-[150px] max-w-[200px] mx-auto mb-12" :src="this.client_logo" alt="screenshot">

                            <div v-if="success == '1'" class="w-full">
                                <svg class="mb-4 h-20 w-20 mx-auto" viewBox="0 0 20 20"
                                    :fill="JSON.parse(client).main_color">
                                    <path fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                        clip-rule="evenodd" />
                                </svg>

                                <h2 class="text-2xl mb-4 text-gray-800 text-center font-bold">
                                    {{ $t("Request sent!") }}
                                </h2>

                                <small class="w-full text-center block">Booking ID:</small>
                                <div
                                    class="flex flex-col items-center justify-center rounded-md bg_primary_color_lightest px-2 py-1 text-xs font-medium primary_color border primaryBorder w-full mb-4 space-y-1">
                                    <h4 class="text-center">
                                        {{ JSON.parse(bookingids)[0] }}
                                    </h4>
                                </div>

                                <div class="text-gray-600 mb-8 text-center">
                                    {{
                                        $t('Thanks you, your booking request has been sent, your host will inform you within 24 hours about the booking status.') }}
                                </div>
                                <div class="text-gray-600 mb-8 text-center">
                                    {{
                                            $t('You can close this page') }}.
                                </div>

                                <button @click="goToRoomSelection()"
                                    class="w-40 block mx-auto focus:outline-none py-2 px-5 rounded-lg shadow-sm text-center text-gray-600 bg-white hover:bg-gray-100 font-medium border">
                                    {{ $t('back-to-home') }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
var moment = require('moment');

import VueLoadImage from 'vue-load-image'
const formatter = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' })
import _ from 'lodash';
import VueCookies from 'vue-cookies'

import AppAccordion from "./items/AppAccordion.vue";

export default {

    components: {
        'vue-load-image': VueLoadImage, AppAccordion
    },
    props: ['client', 'client_logo', 'stripe_info', 'success', 'bookingids'],
    data() {
        return {
            currentUrl: '',
        }
    },
    methods: {
        goToRoomSelection() {
            var newUrl = this.currentUrl + "/book/"+JSON.parse(this.client).id+"/?"
            if (JSON.parse(this.stripe_info)) {
                newUrl += "&checkin=" + moment(JSON.parse(this.stripe_info)['checkin']).format('YYYY-MM-DD')
                newUrl += "&checkout=" + moment(JSON.parse(this.stripe_info)['checkout']).format('YYYY-MM-DD')
            }
            window.location.href = newUrl;
        },
        goBackToPayment() {
            var newUrl = this.currentUrl + "/book/"+JSON.parse(this.client).id+"/payment?"
            newUrl += "&checkin=" + moment(JSON.parse(this.stripe_info)['checkin']).format('YYYY-MM-DD')
            newUrl += "&checkout=" + moment(JSON.parse(this.stripe_info)['checkout']).format('YYYY-MM-DD')
            newUrl += "&setup=" + JSON.parse(JSON.parse(this.stripe_info)['setup']).join('.');
            newUrl += "&bookingIDs=" + JSON.parse(JSON.parse(this.stripe_info)['id']).join('.');
            newUrl += "&pi=" + this.$urlParams.get('payment_intent'); 
            newUrl += "&reserve=true";
            window.location.href = newUrl;
        }
    },
    watch: {
        '$route'() {
            this.loadingScreen = false;
        },
    },
    created() {
        var self = this;
        window.addEventListener("pageshow", function () {
            self.loadingScreen = false;
        }, false);

        this.currentUrl = window.location.origin;
        if (this.success == '1') {
            VueCookies.set('reset', true);
            if (VueCookies.get('paymentIntent')) {
                VueCookies.remove('paymentIntent');
            }
            if (VueCookies.get('assigned')) {
                VueCookies.remove('assigned');
            }
            if (VueCookies.get('step')) {
                VueCookies.set('step', 1);
            }
            if (VueCookies.get('formData')) {
                VueCookies.remove('formData');
            }
            if (VueCookies.get('selectedRooms')) {
                VueCookies.remove('selectedRooms');
            }
            if (VueCookies.get('upsells')) {
                VueCookies.remove('upsells');
            }
            if (VueCookies.get('validUntil')) {
                VueCookies.remove('validUntil');
            }
            if (VueCookies.get('price')) {
                VueCookies.remove('price');
            }
        }
    },
};
</script>